// @/api/model/damandManage.js

import config from "@/config";
import http from "@/utils/request";

export default {
	queryByPage: {
		url: `${config.MAIN_URL}/admin/sysOperationLog/queryByPage`,
		name: "系统操作日志分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},

	queryCompany: {
		url: `${config.MAIN_URL}/admin/sysOperationLog/queryCompany`,
		name: "系统操作日志公司下拉",
		get: async function () {
			return await http.get(this.url);
		},
	},
	queryCompanyCascadeUser: {
		url: `${config.MAIN_URL}/admin/sysOperationLog/queryCompanyCascadeUser`,
		name: "系统操作日志公司人员级联下拉",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},



};
